export default () => {
  $('.js-backToTop').on('click', function() {
    $('html, body').animate({
      scrollTop: 0,
    }, 1500)
  })

  $(window).on('scroll', function() {
    const $button = $('.js-backToTop')
    const $this = $(this)

    if ( !$button.length ) return

    if ( $this.scrollTop() > 100 && !$button.hasClass('is-visible') ) {
      $button.addClass('is-visible')
      return
    }

    if ( $this.scrollTop() <= 100 && $button.hasClass('is-visible') ) {
      $button.removeClass('is-visible')
    }

  })

  $(document).on('click', '.c-joinClubBanner a.wp-block-button__link', function(e) {
    const href= $(this).attr('href')
    if (!href) {
      return
    }

    if ( href.indexOf('#') != -1) {
      e.preventDefault()
      $('html, body').animate({
        scrollTop: 300,
      }, 1500)
    }

  })
}
